type Props = {
  children: React.ReactNode;
};

export const BigNumber = ({ children }: Props): JSX.Element => (
  <p className="m-0 font-firs text-[120px] font-medium leading-none tracking-[-0.22px] lg:text-[200px]">
    {children}
  </p>
);
